import { useExperimentVariables } from '@mc/experiments-react'
import { MCCERTS_2805_HUB_VALUE_PROP_FLAG } from '../constants'
import { parseMccerts2805Variables } from '../variables'

export const useMccerts2805Variables = () => {
  const rawVariables = useExperimentVariables<Record<string, unknown>>(
    MCCERTS_2805_HUB_VALUE_PROP_FLAG,
  )
  return parseMccerts2805Variables(rawVariables)
}
